import { useEffect, useState } from "react";

import { useTerminalContext } from "../contexts/TerminalContext";
import { useConfigFileLoader } from "./useConfigFileLoader";

export const useTerminalConfigLoader = (
  terminalId: number | undefined,
  hasTerminalMismatch: boolean
) => {
  const { setError } = useTerminalContext();
  const { loadConfigFromBackend } = useConfigFileLoader();
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    if (typeof terminalId !== "number" || hasTerminalMismatch) {
      setError(null);
      setIsLoading(false);
      return;
    }
    const controller = new AbortController();
    setIsLoading(true);

    loadConfigFromBackend(terminalId, controller.signal)
      .then(() => {
        setError(null);
        setIsLoading(false);
      })
      .catch((err) => {
        if (err.name === "AbortError") return;
        setError(err.message === "NO_CONFIG_FOUND" ? "NO_CONFIG_FOUND" : "LOAD_ERROR");
        setIsLoading(false);
      });

    return () => controller.abort();
  }, [terminalId, loadConfigFromBackend, setError, hasTerminalMismatch]);

  return isLoading;
};
